/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EditIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "edit", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7 15L6 19L10 18L20 8L17 5L7 15Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M15 7L18 10", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(EditIcon);
export default ForwardRef;
//# sourceMappingURL=editIcon.js.map